export const OFFER_DETAIL_STALE_TIME = 10 * 60 * 1000
